<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../../../stores/auth';
import Loading from '../../Loading.vue';

const router = useRouter();
const authStore = useAuthStore();
onMounted(async () => {
    await authStore.logout();
    router.push("/");
});
</script>

<template>
    <div class="content">
        <div id="login-container">
            <Loading variant="lines" :rows="3" />
        </div>
    </div>
</template>

<style scoped lang="scss">
.content {
    height: 100vh;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    #login-container {
        border-radius: 12px;
        background: #FFF;
        box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.15);
        width: 435px;
        min-width: 340px;
        max-width: 100%;
        padding: 40px;
    }
}
</style>